export default __webpack_public_path__ + "static/ERA_GRIS-a4ba1690eb9ce2c8dd5cf184b284bd2c.png";